export function lock() {
	document.documentElement.classList.add("modal-open");
}

export function unlock() {
	document.documentElement.classList.remove("modal-open");
}
